var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50 14.64-11.33-3.31-3.31-11.33-10.36 5.67-10.36-5.67-3.31 11.33-11.33 3.31 5.67 10.36-5.67 10.36 11.33 3.31 3.31 11.33 10.36-5.67 10.36 5.67 3.31-11.33 11.33-3.31-5.67-10.36z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d307d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.66 25.83c-1.85-1.82-4.82-1.79-6.64.05-1.79 1.82-1.79 4.77 0 6.59.92.93 2.13 1.4 3.35 1.4s2.38-.45 3.29-1.35c1.84-1.82 1.87-4.79 0-6.69zm-2.19 4.47c-.62.61-1.61.6-2.22-.02t0 0c-.6-.61-.6-1.59 0-2.2.31-.31.71-.47 1.11-.47s.81.15 1.13.47c.61.62.6 1.61-.02 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.93 17.48c-1.85-1.82-4.83-1.79-6.64.05-1.79 1.82-1.79 4.77 0 6.59.92.93 2.13 1.4 3.35 1.4s2.38-.45 3.29-1.35c.89-.88 1.39-2.05 1.4-3.31 0-1.25-.47-2.44-1.4-3.39zm-2.19 4.47c-.62.61-1.61.6-2.22-.02-.6-.61-.6-1.6 0-2.2.29-.3.69-.47 1.11-.47h.01c.42 0 .81.16 1.12.47.29.3.45.7.45 1.11 0 .42-.17.81-.47 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83 23.44h20.35v3.12h-20.35z",
    transform: "matrix(.4854201 -.87428103 .87428103 .4854201 -8.99 34.72)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferFilled);
export default __webpack_public_path__ + "static/media/Offer_Filled.ccd84e28f3c70611254cdcbbd85c6f74.svg";
export { ForwardRef as ReactComponent };